import React from 'react';
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { formatFcfa } from '../../utils/formatFcfa';

const SubscriptionCard = ({ 
  plan, 
  isPopular = false, 
  isCurrentPlan = false, 
  onSelectPlan 
}) => {
  const getPlanColor = () => {
    switch (plan.id) {
      case 'basique':
        return 'border-gray-200 bg-white';
      case 'pro':
        return 'border-blue-200 bg-blue-50';
      case 'promax':
        return 'border-primary-200 bg-primary-50';
      case 'boost-ia':
        return 'border-purple-200 bg-purple-50';
      default:
        return 'border-gray-200 bg-white';
    }
  };

  const getButtonColor = () => {
    if (isCurrentPlan) {
      return 'bg-gray-500 text-white cursor-not-allowed';
    }
    switch (plan.id) {
      case 'basique':
        return 'bg-gray-600 text-white hover:bg-gray-700';
      case 'pro':
        return 'bg-blue-600 text-white hover:bg-blue-700';
      case 'promax':
        return 'bg-primary-600 text-white hover:bg-primary-700';
      case 'boost-ia':
        return 'bg-purple-600 text-white hover:bg-purple-700';
      default:
        return 'bg-gray-600 text-white hover:bg-gray-700';
    }
  };

  return (
    <div className={`relative rounded-lg border-2 p-6 ${getPlanColor()} ${
      isPopular ? 'ring-2 ring-primary-500 ring-opacity-50' : ''
    }`}>
      {isPopular && (
        <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
          <span className="bg-primary-500 text-white px-3 py-1 rounded-full text-sm font-medium">
            Populaire
          </span>
        </div>
      )}
      
      {isCurrentPlan && (
        <div className="absolute -top-3 right-4">
          <span className="bg-green-500 text-white px-3 py-1 rounded-full text-sm font-medium">
            Plan actuel
          </span>
        </div>
      )}

      <div className="text-center">
        <h3 className="text-lg font-semibold text-text mb-2">{plan.name}</h3>
        <div className="mb-1">
          <span className="text-3xl font-bold text-text">
            {plan.priceXof ? formatFcfa(plan.priceXof) : '…'}
          </span>
          <span className="text-gray-600">/mois</span>
        </div>
        {plan.promo && <p className="text-xs font-semibold text-red-600 mb-1">Prix promotionnel</p>}
        {plan.priceAnnualXof > 0 && (
          <p className="text-xs text-gray-400 mb-3">ou {formatFcfa(plan.priceAnnualXof)} par an</p>
        )}
        <p className="text-gray-600 text-sm mb-6">{plan.description}</p>
      </div>

      <ul className="space-y-3 mb-6">
        {plan.features.map((feature, index) => (
          <li key={index} className="flex items-start">
            {feature.included ? (
              <CheckIcon className="h-5 w-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" />
            ) : (
              <XMarkIcon className="h-5 w-5 text-gray-400 mr-3 mt-0.5 flex-shrink-0" />
            )}
            <span className={`text-sm ${
              feature.included ? 'text-gray-700' : 'text-gray-400'
            }`}>
              {feature.name}
            </span>
          </li>
        ))}
      </ul>

      <button
        onClick={() => onSelectPlan(plan)}
        disabled={isCurrentPlan}
        className={`w-full py-2 px-4 rounded-lg font-medium transition-colors ${getButtonColor()}`}
      >
        {isCurrentPlan ? 'Plan actuel' : 'Choisir ce plan'}
      </button>
    </div>
  );
};

export default SubscriptionCard;

